import React, { Component } from 'react';
import CustomFormFieldForm from '../../../components/CustomFormFieldForm';
import { Card, CardHeader, Modal, CardBody } from 'reactstrap';

class EditFieldModal extends Component {
  render() {
    const { isOpened, field, save, remove, close } = this.props;

    return (
      <Modal
        zIndex={1000}
        size="lg"
        className="modal-dialog-centered"
        isOpen={isOpened}
        toggle={() => close()}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0 mb-0">
            <CardHeader className="bg-transparent position-relative">
              <div className="text-muted text-center mt-2 mb-2">
                <small>Edit field data</small>
              </div>
              <a
                href="/"
                onClick={e => {
                  e.preventDefault();
                  close();
                }}
                className="position-absolute right-4 top-4 display-4"
              >
                <i className="ni ni-fat-remove text-default" />
              </a>
            </CardHeader>
            <CardBody className="px-lg-5 pt-0">
              <CustomFormFieldForm
                isNew={!field.id}
                onSubmit={save}
                onDelete={() => remove(field.id)}
                initialValues={{ ...field, options: { options: [] } }}
              />
            </CardBody>
          </Card>
        </div>
      </Modal>
    );
  }
}

export default EditFieldModal;
